import React, {useState} from 'react';
import {Col, Row, Typography} from 'antd';
import ReportDateRangeFilter from '../../components/admin/reports/ReportDateRangeFilter';
import DemographicsSection from './reports/patients/DemographicsSection';
import OilTypesChart from './reports/patients/OilTypesChart';
import SocialDiscountsSection from './reports/patients/SocialDiscountsSection';
import RegistrationsChart from './reports/patients/RegistrationsChart';
import ActivitySection from './reports/patients/ActivitySection';
import GrowthChart from './reports/patients/GrowthChart';
import {getStartMonth, getEndMonth} from '../../utils/utils';

export default function AdminReportsPatients() {
    const [dateRange, setDateRange] = useState([getStartMonth(), getEndMonth()]);
    const [appliedRange, setAppliedRange] = useState(dateRange);

    const dateFrom = appliedRange[0].format('YYYY-MM-DD');
    const dateTo = appliedRange[1].format('YYYY-MM-DD');

    return (
        <div>
            <Row justify="space-between" align="middle" style={{marginBottom: 24}} wrap>
                <Col>
                    <Typography.Title level={4} style={{margin: 0}}>Relatórios - Pacientes</Typography.Title>
                </Col>
                <Col>
                    <ReportDateRangeFilter
                        value={dateRange}
                        onChange={setDateRange}
                        onApply={() => setAppliedRange(dateRange)}
                    />
                </Col>
            </Row>

            <div style={{marginBottom: 16}}>
                <DemographicsSection dateFrom={dateFrom} dateTo={dateTo}/>
            </div>

            <Row gutter={[16, 0]}>
                <Col xs={24} lg={12}>
                    <OilTypesChart dateFrom={dateFrom} dateTo={dateTo}/>
                </Col>
                <Col xs={24} lg={12}>
                    <RegistrationsChart dateFrom={dateFrom} dateTo={dateTo}/>
                </Col>
            </Row>

            <div style={{marginBottom: 16}}>
                <SocialDiscountsSection dateFrom={dateFrom} dateTo={dateTo}/>
            </div>

            <Row gutter={[16, 0]}>
                <Col xs={24} lg={12}>
                    <ActivitySection dateTo={dateTo}/>
                </Col>
                <Col xs={24} lg={12}>
                    <GrowthChart dateFrom={dateFrom} dateTo={dateTo}/>
                </Col>
            </Row>
        </div>
    );
}
